/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from 'antd';
import { actions } from "../../store/reducers/authentication";
import Loading from "../Loading";

const mstp = ({ authentication }) => ({ authentication });

const Demo = ({
  authentication: { errors, user, loggingIn },
  demoLogin
}) => {
  const { pathname } = useLocation();
  const goTo = useNavigate();
  const code = pathname.split('/demo/')[1];

  useEffect(() => {
    if (code) {
      demoLogin(code, (success) => {
        if (success) {
          goTo('/app');
        } else {
          message.error('This code is not valid');
          goTo('/');
        }
      });
    }
  }, []);
  return <Loading />;
};

export default connect(mstp, actions)(Demo);
